const enumFormatter = (key, value, model, record, translate) => {
    const { __resource } = model;
    return translate(`resources.${__resource}.enums.${key}.${value}`, {_: value})
};



export default enumFormatter;